export interface Testimonial {
  initials: string
  name: string
  role: string
  text: string
}

export const featuredTestimonials: Testimonial[] = [
  {
    initials: 'RM',
    name: 'R.M.',
    role: 'Golf Instructor, London, UK',
    text: 'I no longer spend my Sunday evenings building lesson structures from scratch. I open the library, pick the session, and walk onto the course completely prepared. My students feel the difference — and so do I.',
  },
  {
    initials: 'DP',
    name: 'D.P.',
    role: 'Golf Instructor, Toronto, Canada',
    text: 'The Coaching Cues & Fault Solutions guide alone saved me multiple times in my first month. That bonus is worth the full price by itself.',
  },
  {
    initials: 'AK',
    name: 'A.K.',
    role: 'Golf Coach, Sydney, Australia',
    text: 'The Drills & Practice Games bank completely changed how I teach. My lessons are more dynamic, my students stay engaged, and every session feels intentional from the first drill to the last.',
  },
]

export const extendedTestimonials: Testimonial[] = [
  {
    initials: 'VT',
    name: 'V.T.',
    role: 'Golf Instructor, New York, USA',
    text: "The full swing progressions completely transformed my students' development. Every week genuinely feels like a real step forward — and I'm not the one rushing to decide what that step should be.",
  },
  {
    initials: 'CR',
    name: 'C.R.',
    role: 'Golf Coach, Melbourne, Australia',
    text: 'I used to get nervous whenever a student at a different level joined the group. Now I open the Adaptation System and I have three versions of every concept ready before anyone arrives. That single bonus changed everything.',
  },
  {
    initials: 'DG',
    name: 'D.G.',
    role: 'Golf Instructor, Toronto, Canada',
    text: "I review the key cues before every session and walk onto the range knowing exactly what I'm going to say. The Coaching Cues guide is something I use every single week without exception.",
  },
  {
    initials: 'AM',
    name: 'A.M.',
    role: 'Golf Academy Instructor, London, UK',
    text: "The Assessment Toolkit saved my academy program. I had everything organized — skill evaluations, progress notes, lesson priorities — all in one place. My students could finally see exactly how far they'd come.",
  },
  {
    initials: 'SR',
    name: 'S.R.',
    role: 'Golf Coach, Dublin, Ireland',
    text: 'The practice games were a complete revelation. My students talk about those sessions for weeks. They feel like a real experience — not just another technical training block.',
  },
]
